<template>
    <v-list class="pa-0" two-line>
        <v-list-item class="pl-0">
            <v-list-item-content>
                <v-list-item-subtitle style="font-size: 12px; user-select: text;">{{sub_title}}
                </v-list-item-subtitle>
                <file-display :src="src" :avatar="avatar"/>
            </v-list-item-content>
        </v-list-item>
        <v-divider :inset="inset" v-if="divider"/>
    </v-list>
</template>

<script>
import FileDisplay from "./FileDisplay";

export default {
    components: {FileDisplay},
    name: "FileListItemDetail",
    props: {
        src: {
            type: [String, File]
        },
        sub_title: {
            type: [String, Number, Boolean],
            default: "N/A"
        },
        divider: {
            type: [Boolean],
            default: false
        },
        inset: {
            type: [Boolean],
            default: false
        },
        avatar: {
            type: [Boolean],
            default: false
        },
    },
    methods: {
        actionClick() {
            this.$emit('actionClick')
        }
    }
}
</script>
